import store from '@/store';
import {eSignChinaApi} from '@/api';
import {isForConvert} from 'Components/viewer/ui/constants';
import { message } from 'antd';
import intl from 'react-intl-universal';
import cuid from 'cuid';
import { toJS } from 'mobx';
import { getBase64Image } from 'Components/EsignChina/gallery-tool/utils';
import { eSignChinaService } from 'Store/services/index';
import { initESignCNMsgTool } from 'Pages/eSignCNWebContainer/service';
// const TOKEN_TIMEOUT_CODE = 610113;
export const ESIGN_CN_SURVEY_RECORD = 'eSignCNSurveyRecord'

export default class ESignChinaService {
    constructor() {

    }

    warnMessage() {
        message.warn({content: "您没有权限填写该表单", duration: 2})
    }
    signProcessMessage(type, content) {
        if (type === 'success') {
            content = content || '操作成功';
            store.appStore.setGlobalMessage({ type: 'success', duration: 2, content, onClose: changeEleStyle });
        } else if (type === 'error') {
            content = content || '操作失败';
            store.appStore.setGlobalMessage({ type: 'error', duration: 2, content, onClose: changeEleStyle });
        } else if (type === 'finished') {
            message.destroy('msg_global');
        } else {
            content = content || '正在加载...';
            // antd支持0，即无限时间，但setGlobalMessage不支持，所以这儿设置一个超大的时间
            // store.appStore.setGlobalMessage({ type: 'loading', duration: 0, content, onClose: changeEleStyle });
            store.appStore.setGlobalMessage({ type: 'loading', duration: 3600, content, onClose: changeEleStyle });
            changeEleStyle(true);
        }
    }

    // *** SaaS版API *** //

    // 获取全局配置
    getESignConfig() {
        const req = eSignChinaApi.getESignConfig();
        return this._resultCheck(req).then(res => res);
    }

    // 上传签名后的文档
    uploadSignedFile({ fileName, blob, processId, recipientOrder }) {
        const req = eSignChinaApi.uploadSignedFile({ fileName, blob, processId, recipientOrder });
        return this._resultCheck(req).then(res => res);
    }

    // 创建签名流程
    createSignProcess({ title,wardType, saveType,creatorName, creatorPhone, creatorEmail, recipients }) {
        const req = eSignChinaApi.createSignProcess({ title,wardType, saveType,creatorName, creatorPhone, creatorEmail, recipients });
        return this._resultCheck(req).then(res => res);
    }

    // 获取流程信息
    getSignFlowInfo({ processId }) {
        const req = eSignChinaApi.getSignFlowInfo({ processId});
        return this._resultCheck(req).then(res => res);
    }

    deleteFlow({processId}) {
        const req = eSignChinaApi.deleteFlow({processId});
        return this._resultCheck(req);
    }

    cancelFlow({processId, comment}) {
        const req = eSignChinaApi.cancelFlow({processId, comment});
        return this._resultCheck(req);
    }

    generateUUID() {
        return cuid();
    }

    // 签名接口
    async signFileDigest({ inner, outer }) {
        const OUTER = "outer";
        const INNER = "inner";
        if ((outer && inner) || (!outer && !inner)) {
            return { stat: 1009, data: null  };
        }
        let type = outer ? OUTER : INNER;
        if ( type === OUTER) {
            return this._signFileDigestForOut(outer);
        } else {
            return this.signFileDigestForInner(inner);
        }
    }

    // 添加存证
    async addEvidenceForSign(data) {
        return eSignChinaApi.addEvidenceForSign(data);
    }

    // 获取存证
    async getEvidenceListForESign(ids) {
        return eSignChinaApi.getEvidenceList(ids);
    }

    handleCheckOutSignSubscriptionError({ silence = false, expire }) {
        let callback = () => {}
        let ok = 'eSignChinaUnite.auth.ok'
        let message = 'eSignChinaUnite.auth.noOutSignPermission'
        if (expire) {
            message = 'eSignChinaUnite.auth.subscriptionExpire'
            ok = 'eSignChinaUnite.auth.contactSales'
            callback = (ok) => {
                ok && window.open('https://www.foxitsoftware.cn/esign#sales');
            }
        }
        !silence && store.appStore.onShowWarningMessage( callback, {
            message,
            closable: true,
            iconType: 'warning',
            ok
        }, true)
    }

    async checkOutSignSubscription(silence) {
        const tenantId = store.userStore && store.userStore.roleInfo && store.userStore.roleInfo.enterpriseId;
        if (tenantId) { // 如果用户选择企业组织来登录账号，则需要校验AC是否对其进行对外签署授权
            let res;
            message.loading({ content: intl.formatMessage({ id: 'eSignChinaUnite.auth.checkOutSignSubscription' }), duration: 3, key: 'check_subscription', onClose: changeEleStyle});
            changeEleStyle(true);
            res = await eSignChinaApi.getEsignCNLicence('external');
            store.esignCnStore.updateOutSignSubscriptionCheckRes(res);
            if (typeof res.code === 'number' && res.code !== 0) {
                const expire = res.code === 600028;
                this.handleCheckOutSignSubscriptionError({ silence, expire });
                return { stat: res.code, error: 'OUT_SIGN_SUBSCRIPTION_ERROR', pass: false };
            } else {
                return { pass: true };
            }
        } else {
            return { pass: true };
        }
    }

    // 获取用户绑定信息
    async verifyUserInformation() {
        const res = {
            stat: 0,
            data : {person: null, orgList: []}
        };
        const {outSignPersonInfo, outSignOrgInfo} = store.esignCnStore;
        if (!outSignPersonInfo || !outSignPersonInfo.name) {
            res.stat = 1;
            return res;
        }
        res.data.person = outSignPersonInfo;
        res.data.orgList = outSignOrgInfo||[];
        return Promise.resolve(res);

        /*
        const pdfUI = store.viewer.pdfui;
        const pdfDoc = await pdfUI.getCurrentPDFDoc();
        const { recipients } = await pdfDoc.getAssignInfoForESignCN();
        const isFlowSign = recipients && recipients.length > 0; // 检查对外签署授权，默认需要检查，但是参与流程签不检查，因为参与签署不花钱；
        let task
        if (noCheckSubscription) {
            task = Promise.resolve()
        } else {
            task = isFlowSign ? Promise.resolve() : this.checkOutSignSubscription();
        }
        return task.then(res => {
            if (res && res.error) {
                return res;
            }
            const tenantId = store.userStore && store.userStore.roleInfo && store.userStore.roleInfo.enterpriseId;
            const req = eSignChinaApi.getESignAccountInfo_V2(tenantId);
           return this._resultCheck(req).then(res => {
               if (res.stat > 0) {
                   return res;
               }
               let { person, orgList } = res.data;
               // 过滤非当前登录企业
               if (orgList && orgList.length > 0) {
                   let temp = [];
                   if (tenantId) {
                       orgList.reverse().some(item => {
                           if (item.tenantId === tenantId) {
                               temp.push(item);
                               return true;
                           }
                       });
                   }
                   orgList = temp;
               } else {
                   orgList = [];
               }
               res.data = {person, orgList};
               return res;
           });
       })

         */
    }

    // 获取e签宝实名认证url
    async getAuthUrl(data) {
        const { pdfUI } = data;
        delete data.pdfUI;
        const { userEmail, userMobile } = store.userStore.userInfo;
        let account, mobile;
        if (userEmail) {
            account = userEmail;
        } else if (userMobile) {
            mobile = userMobile;
            if (userMobile.indexOf('+86') === 0 && userMobile.length === 14) {
                mobile = userMobile.substr(3, 11);
            }
            if (mobile.length === 11) {
                account = mobile;
            } else {
                this.signProcessMessage('error','实名认证失败，当前服务仅支持中国大陆手机号');
                return false;
            }
        } else {
            this.signProcessMessage('error','实名认证失败，未能获取邮箱或手机号');
            return false;
        }
        data.account = account;
        this.signProcessMessage('process', '开始认证…');
        let result = await this._resultCheck(eSignChinaApi.getAuthUrl_V2(data));
        this.signProcessMessage('finished');
        if (result.stat > 0) {
            this.signProcessMessage('error',"认证请求失败");
            return false;
        }

        const url = result.data;
        result = null;
        const callback = (res) => {
            if (res) {
                if (res.stat > 0) {
                    this.signProcessMessage('error','实名认证失败');
                    result = false;
                } else {
                    result = true;
                }
            } else {
                result = false;
            }
        };
        const orgName = store.userStore.userInfo.enterpriseName;
        const tenantId = store.userStore && store.userStore.roleInfo && store.userStore.roleInfo.enterpriseId;
        pdfUI.customs.showESignCNManageOutSealDialog({type: 'oAuth', data: {url, email:userEmail, mobile, orgName, tenantId, authParams: data, callback, pdfUI}});
        let timer = null;
        return new Promise((resolve) => {
            timer = setInterval( () => {
                if (result !== null) {
                    clearInterval(timer);
                    timer = null;
                    resolve(result);
                }
            }, 500);
        });

        // authWindow.location = res.data;
        // return this._doListenSubWindowAction(accountType, account, undefined, data);
    }

    // 获取e签宝意愿认证url
    async handleWillingnessAuth_V2(data) {
        this.signProcessMessage('process', '开始认证…');
        const { pdfUI } = data;
        delete data.pdfUI;
        let result = await this._resultCheck(eSignChinaApi.createWillingnessAuth_V2(data));
        this.signProcessMessage('finished');
        if (result.stat > 0) {
            this.signProcessMessage('error',"认证请求失败");
            return null;
        }

        const { bizId, shortUrl} = result.data;
        result = null;
        const callback = (res) => {
            if (res) {
                if (res.stat > 0) {
                    this.signProcessMessage('error',"意愿认证失败");
                    result = false;
                } else {
                    result = res.data;
                }
            } else {
                result = false;
            }
        };
        pdfUI.customs.showESignCNManageOutSealDialog({type: 'willAuth', data: {url: shortUrl, bizId, callback, pdfUI}});
        let timer = null;
        return new Promise((resolve) => {
            timer = setInterval( () => {
                    if (result !== null) {
                        clearInterval(timer);
                        timer = null;
                        resolve(result);
                    }
            }, 500);
        });


        // willAuthWindow.location = shortUrl;
        // result = await this._doListenSubWindowAction(undefined, undefined, bizId);
        // if (result.stat > 0) {
        //     return result;
        // }
        // const { status, willAuthType, endTime, willAuthId } = result.data;
        // if (status !== 1 ) {
        //     result.stat = 1008;
        //     return result;
        // }
        // result.data =  { willingnessBizId: bizId, willAuthId, willAuthType, willAuthTime: endTime};
        // return result;
    }

    // 获取印章列表 个人 企业
    getMySignStampList({ person, orgList }) {
        if (orgList && orgList.length > 0) {
            const { accountId } = person;
            const { name, authType, authTime, orgId } = orgList[0];
            const enterpriseId = store.userStore && store.userStore.roleInfo && store.userStore.roleInfo.enterpriseId;
            return this._resultCheck(eSignChinaApi.getOrgTemplateSeal_V3({ orgId, accountId, enterpriseId })).then(res => {
                if (res.stat > 0 && res.stat !== 600030) { // 600030 该用户没有对外授权，无法获取企业印章列表，该状态 需要按 企业印章列表为空处理。
                    return res;
                }
                if (res.stat === 600030) {
                    res.data = { seals: [] }
                }
                let list = res.data.seals;
                if (list && list.length > 0) {
                    list.forEach(item => {
                        item.accountId = orgId;
                        item.authType = authType;
                        item.authTime = authTime;
                        item.name = name;
                        item.source = item.url;
                    });
                } else {
                    list = [];
                }

                res.data = list;
                return res;
            });
        } else {
            const { name, authType, authTime, accountId } = person;
            return this._resultCheck(eSignChinaApi.getPersonTemplateSeal_V2({ accountId })).then(res => {
                if (res.stat > 0) {
                    return res;
                }
                let list = res.data.seals;
                if (list && list.length > 0) {
                    list.forEach(item => {
                        item.accountId = accountId;
                        item.authType = authType;
                        item.authTime = authTime;
                        item.name = name;
                        item.source = item.url;
                    });
                } else {
                    list = [];
                }
                res.data = list;
                return res;
            });
        }
    }

    // 获取当前账号个人信息，并且包含所属企业名称
    getUserInfoForESignCN(isOrg = false) {
        const info = store.userStore.userInfo;
        info.outSignPersonInfo = store.esignCnStore.outSignPersonInfo;
        info.outSignOrgInfo = toJS(store.esignCnStore.outSignOrgInfo);
        const enterpriseId = store.userStore && store.userStore.roleInfo && store.userStore.roleInfo.enterpriseId;
        info.enterpriseId = enterpriseId;
        if (isOrg) {
            if (!enterpriseId) {
                return Promise.resolve({ stat: 0, data: info });
            }
            if (info.outSignOrgInfo && info.outSignOrgInfo.length > 0 && info.outSignOrgInfo[0].name) {
                const item = info.outSignOrgInfo.find(item => item.tenantId === enterpriseId);
                if (item) {
                    info.enterpriseName = info.outSignOrgInfo.find(item => item.tenantId === enterpriseId).name;
                    return Promise.resolve({ stat: 0, data: info });
                }
            }
            return this._resultCheck(eSignChinaApi.getSubscription({ tenantId: enterpriseId })).then(res => {
                if (res.stat > 0) {
                    return res;
                }
                info.enterpriseName = res.data.tenantName;
                res.data = info;
                return res;
            });
        } else {
            return Promise.resolve(info);
        }
    }

    // 获取当前账户的过期时间和剩余份数
    // 区分个人和企业
    // 判断是否过期，未过期时判断是否足够签
    async getUserSubscriptionForESignCN(cnt, enterpriseId) {
        const data = {
            allow: false, // 是否允许签名
            expre: true, // 是否过期
            cnt: 0, // 剩余可用数
            expreTime: 0, // 过期时间,
            isTrial: null // 0代表app store订阅，1代表赠送
        };

        const params = enterpriseId ? {tenantId: enterpriseId } : {};
        const result = await this._resultCheck(eSignChinaApi.getSubscription(params));
        if (result.stat > 0) {
            return result;
        }
        const {expreTime, docNumber, serverTime, isTrial} = result.data;
        if (docNumber !== null && expreTime !== null) {
            data.cnt = docNumber;
            data.expreTime = expreTime;
            data.isTrial = isTrial;
            data.docNumber = docNumber;
            if (expreTime - serverTime > 0) {
                data.expre = false;
                if (docNumber >= cnt) {
                    data.allow = true;
                    result.data = data;
                    return result;
                }
            }
        }

        result.data = data;
        return result;
    }

    // 获取易签宝创建界面url
    getCreateUrl({ accountId, orgId }) {
        const errorCodeCallback = (res) => {
            if (res.code === 600062) {
                let eSignCode = res.msg.split('|')[1];
                const orgStampList = store.esignCnStore.outSignStampList && store.esignCnStore.outSignStampList.filter(it => it.isOrg);
                if (!orgStampList || orgStampList.length < 1) {
                    eSignCode = "0"
                }
                let msg;
                switch (eSignCode) {
                    case "0":
                        msg = 'noAccessStampAdminPermission.applyOrgStampUsePermission'
                        break;
                    case "31401007":
                        msg = 'noAccessStampAdminPermission.noPermission';
                        break;
                    case "1000000":
                        msg = "noAccessStampAdminPermission.noPermission"
                        break;
                    case "10000001":
                        msg = "noAccessStampAdminPermission.eSignSystemError"
                        break;
                    case "10000007":
                        msg =  "noAccessStampAdminPermission.paramsError"
                        break;
                    default:
                        msg = "noAccessStampAdminPermission.extraContent"
                }
                store.appStore.onShowWarningMessageAsync({
                    message: msg,
                    iconType: 'alert',
                    cancel: "noAccessStampAdminPermission.btn",
                    noCancel: false,
                    closable: true,
                    noConfirm: true,
                    zIndex: 99999
                }, false);
            }
        }
        if (!orgId) {
            const req = eSignChinaApi.getPersonCreateUrl(accountId);
            return this._resultCheck(req).then(res => {
                if (res.stat > 0) {
                    return res;
                }
                res.data = res.data.PsnSealCreateUrl;
                return res;
            });
        } else {
            const req = eSignChinaApi.getOrgCreateUrl(orgId);
            return this._resultCheck(req, errorCodeCallback).then(res => {
                if (res.stat > 0) {
                    return res;
                }
                res.data = res.data.PsnSealCreateUrl;
                return res;
            });
        }
    }

    // 获取易签客管理界面url
    getAdminUrl({ accountId, orgId, errorCallback }) {
        const errorCodeCallback = errorCallback || ((res) => {
            if (res.code === 600062) {
                let eSignCode = res.msg.split('|')[1];
                const orgStampList = store.esignCnStore.outSignStampList && store.esignCnStore.outSignStampList.filter(it => it.isOrg);
                if (!orgStampList || orgStampList.length < 1) {
                    eSignCode = "0"
                }
                let msg;
                switch (eSignCode) {
                    case "0":
                        msg = 'noAccessStampAdminPermission.applyOrgStampUsePermission'
                        break;
                    case "31401007":
                        msg = 'noAccessStampAdminPermission.noPermission';
                        break;
                    case "1000000":
                        msg = "noAccessStampAdminPermission.noPermission"
                        break;
                    case "10000001":
                        msg = "noAccessStampAdminPermission.eSignSystemError"
                        break;
                    case "10000007":
                        msg =  "noAccessStampAdminPermission.paramsError"
                        break;
                    default:
                        msg = "noAccessStampAdminPermission.extraContent"
                }
                store.appStore.onShowWarningMessageAsync({
                    message: msg,
                    iconType: 'alert',
                    cancel: "noAccessStampAdminPermission.btn",
                    noCancel: false,
                    closable: true,
                    noConfirm: true,
                    zIndex: 99999
                }, false);
            }
        })

        if (!orgId) {
            const req = eSignChinaApi.getPersonAdminUrl(accountId);
            return this._resultCheck(req).then(res => {
                if (res.stat > 0) {
                    return res;
                }
                res.data = res.data.managePsnSealUrl;
                return res;
            });
        } else {
            const req = eSignChinaApi.getOrgAdminUrl(orgId);
            return this._resultCheck(req, errorCodeCallback).then(res => {
                if (res.stat > 0) {
                    return res;
                }
                res.data = res.data.SealManagmentUrl;
                return res;
            });
        }
    }


    _doShowSignInDialog(name){
        let id = isForConvert(name)? "Permission.SignIn.Convert":"Permission.SignIn";
        store.appStore.doUpdateSignInNotice({id});
    }

    _signFileDigestForOut({signId, operatorId, hash, signerId, willingnessBizId,chapterType,processId, recipientOrder,docId,from, chargeFlag}) {
        let tenantId = (store.userStore.roleInfo && store.userStore.roleInfo.enterpriseId) || "";
        const req = eSignChinaApi.signFileDigest_V2(
          {hash, operatorId, signerId, willingnessBizId,chapterType,tenantId,docId,from, signId, processId, recipientOrder, chargeFlag});
        return this._resultCheck(req);
    }

    // 离线文档 签署完成确认
    esignConfirm({ processId, recipientOrder}) {
        return this._resultCheck(eSignChinaApi.esignConfirm({ processId, recipientOrder}));
    }


    // 请求结果处理
    _resultCheck(request, errorCodeCallback, httpErrorCallback) {
        const temp = { stat: 1001, data: null };
        let msg = null;
        return new Promise(resolve => {
            request.then(res => {
                if (!res ) {
                    if (httpErrorCallback) {
                        httpErrorCallback()
                    } else {
                        msg = intl.formatMessage({ id: 'NetworkError' });
                    }
                } else if (res.code ) {
                    if (errorCodeCallback) {
                        errorCodeCallback(res);
                    } else {
                        temp.stat = res.code;
                        temp.msg = res.msg;

                        if (res.code === 610171) {
                            msg = '您的账户因存在安全风险已被限制，请联系客服（support@foxitsoftware.cn）';
                        }
                        else if (res.code === 610170) {
                            msg = '操作过于频繁，请稍后重试';
                        }
                        else if (res.code === 610172) {
                            msg = '签署额度扣除失败，请稍后重试';
                        }
                        else if (res.code !== 610113 && res.code !== 600030) { // 610113为e签宝token过期，该异常已另外单独处理，此处不做消息提示。 600030为 对外签署授权错误，该异常已另外单独处理
                            msg = intl.formatMessage({ id: 'NetworkError' }) + ": " + res.code;
                        }

                    }
                } else {
                    temp.data = res;
                    temp.stat = 0;
                }
                if (msg) {
                    store.appStore.setGlobalMessage({ type: 'error', content: msg, onClose: changeEleStyle });
                }
            }).catch(error => {
                if (httpErrorCallback) {
                    httpErrorCallback()
                } else {
                    if (error.__CANCEL__) {
                        msg = intl.formatMessage({ id: 'CancelRequest' });
                    } else if (error.message.includes('timeout')) {
                        msg = "网络超时，请重试";
                        temp.stat = 1002;
                    } else {
                        msg = intl.formatMessage({ id: 'NetworkError' });
                    }
                    store.appStore.setGlobalMessage({ type: 'error', duration: 2, content: msg, onClose: changeEleStyle });
                }
            }).finally(() => {
                resolve(temp);
            });
        });
    }

// ------------------ underline is inner api -----------


    signFileDigestForInner({ signId, hash, signerId, processId, recipientOrder }) {
        return this._resultCheck(eSignChinaApi.signatureFileDigestInner({signId, hash, signerId, processId, recipientOrder}));
    }

    getAccountSubscription({
        wardType,
        tenantId
    }) {
        return eSignChinaApi.getAccountSubscription({tenantId, wardType});
    }
    innerSealCreate({
        signerId,
        pictureBase64
    }) {
        return eSignChinaApi.innerSealCreate({signerId, pictureBase64});
    }
    getInnerSealList() {
        return eSignChinaApi.getInnerSealList().then(res => {
            if (res.lists) {
                store.esignCnStore.setInnerStampList(res.lists);
            }
            return res;
        });
    }
    innerSealDisable({ sealId }) {
        return eSignChinaApi.innerSealDisable({ sealId });
    }
    getUserSignLog({
        wardType,
        page,
        pageSize
    }) {
        return eSignChinaApi.getUserSignLog({
            wardType,
            page,
            pageSize
        });
    }
    getUserSubscription({
        wardType
    }) {
        return this._resultCheck(eSignChinaApi.getUserSubscription({ wardType }));
    }
    getRecordSubscription({
        wardType
    }) {
        return eSignChinaApi.getUserSubscription({
            wardType
        });
    }
    getJwtToken(enterpriseId) {
        return this._resultCheck(eSignChinaApi.getJwtToken(enterpriseId));
    }
    checkJwtToken(jwt, bIgnoreTime) {
        return eSignChinaApi.checkJwtToken(jwt, bIgnoreTime);
    }
    getSAMLResponse() {
        return this._resultCheck(eSignChinaApi.getSAMLResponse());
    }
    ValidateSAMLResponse(SAML) {
        return eSignChinaApi.ValidateSAMLResponse(SAML);
    }
    ValidateSAMLResponseAllInfo(param) {
        return eSignChinaApi.ValidateSAMLResponseAllInfo(param);
    }
    getEnterpriseUser(enterpriseId){
        return eSignChinaApi.getEnterpriseUser(enterpriseId)
    }
    getUserRole(enterpriseId){
        return eSignChinaApi.getUserRole(enterpriseId)
    }
    getEsignCNLicence(product){
        return eSignChinaApi.getEsignCNLicence(product);
    }
    getSignProcessList({processId,role,wardType,name,status,  perPage, currentPage,errCallback}){
        return eSignChinaApi.getSignProcessList({processId,role,wardType,name,status, perPage, currentPage,errCallback})
    }
    getSignProcessListTotal(){
        return eSignChinaApi.getSignProcessListTotal()
    }
    noticeSign(processId){
        return eSignChinaApi.noticeSign(processId)
    }
    updateESignCN_ActiveFieldList(list) {
        return store.esignCnStore.updateESignCN_ActiveFieldList(list);
    }

    updateESignCN_TotalActiveFieldList(list) {
        return store.esignCnStore.updateESignCN_TotalActiveFieldList(list);
    }

    cleanActiveFieldList() {
        return store.esignCnStore.cleanActiveFieldList()
    }

    cleanTotalFieldList() {
        return store.esignCnStore.cleanTotalFieldList()
    }

    isESignCNField(fieldObjectNum) {
        let ret = {
            isESignCNField: false
        };
        let totalList;
        totalList = toJS(store.esignCnStore.eSignCN_TotalActiveFieldList).map(item => {
            if (item.color === toJS(store.esignCnStore.eSignCN_ActiveFieldList).color) {
                return toJS(store.esignCnStore.eSignCN_ActiveFieldList)
            } else {
                return item;
            }
        })
        if (totalList.length === 0) {
            toJS(store.esignCnStore.eSignCN_ActiveFieldList) && totalList.push(toJS(store.esignCnStore.eSignCN_ActiveFieldList))
        }

        if (!totalList || totalList.length < 1) {
            return ret
        }
        const bool = totalList.some(item => item.color === toJS(store.esignCnStore.eSignCN_ActiveFieldList).color)
        if (!bool) {
            totalList.push(toJS(store.esignCnStore.eSignCN_ActiveFieldList))
        }

        totalList.map(item => item.fields).reduce((previousValue, currentValue) => {
            return [...previousValue, ...currentValue]
        }, []).forEach(item => {
            if (item.id === fieldObjectNum && (item.signChinaType === "Title" || item.signChinaType === "Date")) {
                ret.isESignCNField = true;
            }
        })
        return ret;
    }

    getESignCNInitSignFieldsColor() {
        return toJS(store.esignCnStore.initSignFieldsColor)
    }
    updateInitSignFieldsColor(item, type) {
        store.esignCnStore.updateInitSignFieldsColor(item, type)
    }
    cleanInitSignFieldsColor() {
        store.esignCnStore.cleanInitSignFieldsColor()
    }
    async enterPersonCreate () {
        const  { outSignPersonInfo} = store.esignCnStore;
        if (!outSignPersonInfo || !outSignPersonInfo.accountId) {
            return Promise.reject('用户信息获取失败');
        }
        const req = eSignChinaApi.getPersonCreateUrl(outSignPersonInfo.accountId);
        return this._resultCheck(req).then(res => {
            if (res.stat > 0) {
                return res;
            }
            res.data = res.data.PsnSealCreateUrl;
            return res;
        });
    }
    async enterPersonAdmin() {
        const  { outSignPersonInfo} = store.esignCnStore;
        if (!outSignPersonInfo || !outSignPersonInfo.accountId) {
            return Promise.reject('用户信息获取失败');
        }
        const req = eSignChinaApi.getPersonAdminUrl(outSignPersonInfo.accountId);
        return this._resultCheck(req).then(res => {
            if (res.stat > 0) {
                return res;
            }
            res.data = res.data.managePsnSealUrl;
            return res;
        });


        // const { pass } = await this.checkOutSignSubscription();
        // if (!pass) return;
        // let { outSignPersonInfo: person } = store.esignCnStore;
        // if(!person || Object.keys(person).length < 1) {
        //     await store.esignCnStore.fetchOutSignUserInfo()
        //     person = store.esignCnStore.outSignPersonInfo;
        // }
        // const accountId = person?.accountId
        // const res = await this.getAdminUrl({accountId})
        // return this.handleEnterAdminResponse(res, false, callback, pdfUI)
    }
    async enterOrgAdmin() {
        const { outSignOrgInfo } = store.esignCnStore;
        if (!outSignOrgInfo || !outSignOrgInfo[0] || !outSignOrgInfo[0].orgId) {
            return Promise.reject('企业信息获取失败');
        }
        const req = eSignChinaApi.getOrgAdminUrl(outSignOrgInfo[0].orgId);
        return this._resultCheck(req).then(res => {
            if (res.stat > 0) {
                return res;
            }
            res.data = res.data.SealManagmentUrl;
            return res;
        });


        // const { pass } = await this.checkOutSignSubscription();
        // if (!pass) return;
        // let { outSignOrgInfo: orgList } = store.esignCnStore;
        // if (!orgList || orgList.length < 1) {
        //     await store.esignCnStore.fetchOutSignUserInfo()
        //     orgList = store.esignCnStore.outSignOrgInfo;
        // }
        // const orgId = orgList?.[0]?.orgId;
        // const res = await this.getAdminUrl({orgId, errorCallback});
        // return this.handleEnterAdminResponse(res, true, callback, pdfUI);
    }
    /*
    async handleEnterAdminResponse(res, isOrg, callback, pdfUI, isCreate = false) {
        if (res.stat === 0 && res.data) {

            pdfUI.customs.showESignCNManageOutSealDialog({type: 'seals', data: {url: res.data, isOrg, callback, pdfUI, isCreate}});
            return

            // const iWidth = isOrg ? 1273 : 1217;
            // const openWin = openWindow({iWidth, iHeight:600, url: res.data});
            // window.addEventListener('message', receiveMessage => {
            //     const type = receiveMessage.data?.type;
            //     if (type === 'close') {
            //         openWin.close();
            //     }
            // }, false);
            // let timer = setInterval(() => {
            //     if (openWin.closed) {
            //         callback()
            //         window.clearInterval(timer);
            //         timer = null;
            //     }
            // },100);
            // // window.open(res.data);
            // return;
        }
        if (res.stat > 0 && res.stat === TOKEN_TIMEOUT_CODE) {
            const isOK = await store.appStore.onShowWarningMessageAsync({
                message: 'eSignChinaUnite.gallery.personESignTokenTimeOut', // todo 切换词条
                iconType: 'warning',
                ok: 'eSignChinaUnite.gallery.authorizeBtn',
                cancel: "eSignChinaUnite.gallery.cancelAuthorizeBtn",
                noCancel: false,
                closable: true
            }, false);
            if (isOK) {
                const personAuthCallback = ({ stat }) => {
                    if (stat === 0) {
                        if (isOrg) {
                            this.enterOrgAdmin(callback, pdfUI)
                        } else {
                            this.enterPersonAdmin(callback, pdfUI)
                        }
                    }
                }
                openAuthForOutSign(false, undefined, pdfUI, personAuthCallback)
            }
            return []
        }
    }
*/
    // 考虑到不再在editorContainer.js中的入口方法中增加专门的对内方法，此处复用对外方法，并通过第一个参数isInner区分
    async updateOutSignStampList(isInner, _person, _orgList, personSeals, orgSeals) {
        if (isInner) {
            return store.esignCnStore.getInnerStampList();
        }
        let stampList = []
        try {
            await store.esignCnStore.fetchOutSignUserInfo(_person, _orgList)
            const { outSignPersonInfo: person, outSignOrgInfo } = store.esignCnStore;
            const orgList = toJS(outSignOrgInfo);
            if (person && person.accountId) {
                const personStamp = await this._getPersonStampList(person, personSeals)
                stampList = [...personStamp]
            }
            if(orgList && orgList[0] && orgList[0].name) {
                const orgStampList = await this._getOrgStampList(person, orgList, orgSeals)
                stampList = [...stampList, ...orgStampList]
            }
        } finally {
            store.esignCnStore.updateOutSignStampList(stampList)
        }
    }

    async _getPersonStampList(person, personSeals) {
        if (personSeals && personSeals.length > 0) {
            return await this._formatSeals(personSeals, false,  person);
        }
        const res = await this.getMySignStampList({ person })
        if (res.stat === 0 && res.data && res.data.length > 0) {
            return await this._formatSeals(res.data);
        }
        if (res.stat > 0) {
            return Promise.reject({stat: res.stat})
        }
    }

    async _formatSeals(seals, isOrg, person, org) {
        for(let i = 0; i < seals.length; i++) {
            const item = seals[i];
            if (!item.source) {
                if (!isOrg && person) {
                    const { name, authType, authTime, accountId } = person;
                    item.accountId = accountId;
                    item.authType = authType;
                    item.authTime = authTime;
                    item.name = name;
                }

                if (isOrg && org) {
                    const { name, authType, authTime, orgId } = org;
                    item.accountId = orgId;
                    item.authType = authType;
                    item.authTime = authTime;
                    item.name = name;
                }

                item.source = item.url;
            }

            const base64 = await getBase64Image(item.source)
            item.imgUrl = base64; // for eSignChina -> signatureFn
            item.src = base64; // for Gallery组件
            item.isOrg = isOrg;
            item.id = item.sealId; // Gallery组件需要用id作为render list key
        }
        return seals;
    }

    async _getOrgStampList(person, orgList, orgSeals) {
        if (orgSeals && orgSeals.length > 0) {
            return await this._formatSeals(orgSeals, true, undefined, orgList[0]);
        }
        const res = await this.getMySignStampList({person, orgList})
        if (res.stat === 0) {
            let orgStampList = [];
            if (res.data && res.data.length > 0) {
                orgStampList = await this._formatSeals(res.data, true);
            }
            return orgStampList;
        }
        if (res.stat > 0) {
            return Promise.reject(res)
        }
    }
    searchEmailForSign(params) {
        return eSignChinaApi.searchEmailForSign(params)
    }
    getURL_ESIGNCN() {
        return eSignChinaApi.getURL_ESIGNCN();
    }

    searchFlowMan(params) {
        return eSignChinaApi.searchFlowMan(params)
    }

    async handleESignCNSurveyLogic() {
        const init = () => {
            const eSignCNSurveyRecord = {
                firstSign: {
                    date: Date.now(),
                },
                showPopupCounts: 1
            }
            localStorage.setItem(ESIGN_CN_SURVEY_RECORD, JSON.stringify(eSignCNSurveyRecord))
            store.esignCnStore.updateESignCNSurveyVisible(true);
        }
        const data = localStorage.getItem(ESIGN_CN_SURVEY_RECORD);
        if (data) {
            const eSignCNSurveyRecord = JSON.parse(data);
            if (!eSignCNSurveyRecord.hasFinishSurvey && eSignCNSurveyRecord.showPopupCounts === 1) {
                // const firstSignDate = eSignCNSurveyRecord.firstSign.date;
                const processRecord = await eSignChinaService.getSignProcessList({
                    role: 0,
                    sort: 'createTime desc',
                    perPage: 10,
                    currentPage: 1,
                    errCallback: (err) => {
                        console.log(err);
                    },
                });
                if (processRecord.code && processRecord.code !== 0) {
                    return;
                }
                let signRecord = processRecord.list.map(item => item.signRecipientList)
                signRecord = [].concat.apply([], signRecord)
                const email = store.userStore.userInfo.userEmail;
                const phone = store.userStore.userInfo.phone;
                const threeDayStamp = 24 * 3600;
                const targetStamp = eSignCNSurveyRecord.firstSign.date + threeDayStamp;
                const targetRecord = signRecord.filter( item => {
                    if (item.email !== email && item.phone !== phone) {
                        return false;
                    }
                    if (item.status !== 4) { // 0表示签署者已经添加到流程；1表示已经给签署者发了通知；2表示签署者已经查看了签署详情；3表示正在签署中；4表示签署已完成
                        return false;
                    }
                    if (parseInt(item.update_time)*1000 < targetStamp) {
                        return false;
                    }
                    return true;
                })
                if(targetRecord.length > 0) {
                    const npsSurveyEle = document.querySelector('.nps-survey');
                    if (npsSurveyEle) { // 如果存在nps调查问卷，则不展示eSignCN问卷
                        return;
                    }
                    eSignCNSurveyRecord.showPopupCounts = eSignCNSurveyRecord.showPopupCounts + 1;
                    localStorage.setItem(ESIGN_CN_SURVEY_RECORD, JSON.stringify(eSignCNSurveyRecord))
                    store.esignCnStore.updateESignCNSurveyVisible(true);
                }
            }
        } else {
            const npsSurveyEle = document.querySelector('.nps-survey');
            if (npsSurveyEle) { // 如果存在nps调查问卷，则不展示eSignCN问卷
                return;
            }
            init()
        }
    }
    handleApplyOutStampUsePermission(data, httpErrorCallback) {
        const req = eSignChinaApi.applyOutStampUsePermission(data);
        return this._resultCheck(req, undefined, httpErrorCallback);
    }
    handleResendApplyOutStampUsePermission(data, httpErrorCallback) {
        const req = eSignChinaApi.resendApplyOutStampUsePermission(data);
        return this._resultCheck(req,undefined, httpErrorCallback);
    }
    updateAuditTrailData(docHash, data) {
        store.esignCnStore.updateAuditTrailData(docHash, data)
    }
    getAuditTrailData(docHash) {
        store.esignCnStore.getAuditTrailData(docHash)
    }
    initESignCNMsgTool() {
        return initESignCNMsgTool()
    }
}

function changeEleStyle(isShow = false) { // 设置遮罩
    setTimeout(() => {
        const el = document.querySelector(".ant-message");
        if (!el) return;
        el.style.pointerEvents = isShow ? "all" : "";
        el.style.backgroundColor = isShow ? "translate" : ""; // translate
        el.style.height = isShow? "100vh" : "";
    }, 100);
}

// function sleep(time) {
//     return new Promise(resolve => setTimeout(resolve(), time));
// }
